module.exports = __webpack_public_path__ + "static/assets/1a4246535a92cfbbabbd0a849b105b1d.svg";